// extracted by css-extract-rspack-plugin
export default {"description":"common__description--bodZG"};